import React from 'react';

import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import CoachingConstants from 'coaching/CoachingConstants';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  eventPrefix?: string;
  onCancelPlan: () => void;
};

export default function ManageRecurringSession({ onCancelPlan, eventPrefix }: Props) {
  return (
    <>
      <BoxBody size="xsmall">
        <Row size="small">
          <Text>
            Contact us to update the day, time, length, or frequency of recurring sessions with your
            current tutor or to get matched with a new tutor.
          </Text>
        </Row>
        <Row size="small">
          <Button
            data-test="request-schedule-update"
            href={`${CoachingConstants.TUTORING_HELP_FORM_ROUTE}?request=c_update_plan`}
            eventKey={eventPrefix && `${eventPrefix}.request_plan_update.click`}
            target="_blank"
            level="secondary"
            color="graphite"
            full>
            Request schedule update
          </Button>
        </Row>
        <Row size="small">
          <Button
            data-test="continue-to-cancel-recurring-schedule"
            eventKey={eventPrefix && `${eventPrefix}.cancel_plan.click`}
            level="secondary"
            color="apple"
            onClick={onCancelPlan}
            full>
            <Text size="xxsmall">Cancel recurring session</Text>
          </Button>
        </Row>
      </BoxBody>
    </>
  );
}
